module.exports = __webpack_public_path__ + "img/clocks-icon.6445c095.svg";